import { NgModule } from '@angular/core';
import { ResetPasswordComponent } from './reset.password.component';
import { ChangePasswordComponent } from './change.password.component';
import { SetPasswordComponent } from './set.password.component';
import { CxFormsModule } from '@forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { UiFormatModule } from '@ui-format';


@NgModule({
    imports : [
        BrowserModule,
        CxFormsModule,
        FormsModule,
        ReactiveFormsModule,
        UiFormatModule
    ],
    declarations : [
        ResetPasswordComponent,
        ChangePasswordComponent,
        SetPasswordComponent
    ],
    providers : [],
    exports : [
        ResetPasswordComponent,
        SetPasswordComponent,
        ChangePasswordComponent
    ]
})
export class ChangePasswordModul {

}

export {
    ResetPasswordComponent,
    ChangePasswordComponent,
    SetPasswordComponent
}